// This is a modified version of the one in PlatformFrontendPackage
// since MAX does not use a compatible technology stack and
// PlatformFrontendPackage does not yet seperate Vue3 and other dependencies.
// Make sure any relevant changes are ported back.
 
import axios from 'axios';
import { DateTime } from 'luxon';


const ActiveUserPingInterval = 60000;
const ActiveUserPingMinTime = ActiveUserPingInterval - 1000;


export function initPlatformApplication(application: number)
{
    // Immediately trigger, debounced in the function
    _userActivePing(application);
}



async function _userActivePing(application: number)
{
    const key = `activeUserPing.${application}`;

    // Use localStorage both for debouncing after a refresh, and when
    // multiple tabs are open.
    const lastPing = localStorage.getItem(key);
    const now = DateTime.now();

    if (!!lastPing)
    {
        var lastPingDateTime = DateTime.fromISO(lastPing);
        if (now.diff(lastPingDateTime).as('milliseconds') < ActiveUserPingMinTime)
        {
            setTimeout(() => _userActivePing(application), ActiveUserPingInterval);
            return;
        }
    }

    localStorage.setItem(key, now.toISO());

    try
    {
        await axios.get(`/api/identity/v2/active/ping/${application}`);
    }
    finally
    {
        setTimeout(() => _userActivePing(application), ActiveUserPingInterval);
    }
}
